import { createSlice } from '@reduxjs/toolkit';
import reducers from './reducers';
import extraReducers from './extraReducers';
export * from '../../thunk/healthCheck';

const HealthCheckSlice = createSlice({
    name: 'healthCheck',
    initialState: {
        data: null,
        status: null,
        error: null,
        queryParams: {},
    },
    reducers,
    extraReducers
});

const { actions, reducer } = HealthCheckSlice;
export const { setHealthCheckData, clearHealthCheckFilters } = actions;
export { reducer }; 